import { useEffect, useState } from "react";
import { MessageCircleHeart, Trash2, Mic, Video } from "lucide-react";
import { toast } from "sonner";
import { recordingReplies, deleteRecordingReply } from "../../lib/api";

const API = process.env.REACT_APP_BACKEND_URL;
const when = (iso) => new Date(iso).toLocaleDateString(undefined, { month: "short", day: "numeric", year: "numeric" });

export const ReplyCard = ({ r, src, onDelete }) => (
  <li className="rounded-xl border border-border bg-card px-3 py-2.5 text-sm" data-testid={`reply-${r.id}`}>
    <div className="flex items-center gap-2">
      <span className="font-medium flex items-center gap-1.5">{r.kind === "audio" ? <Mic className="h-3.5 w-3.5 text-primary" /> : r.kind === "video" ? <Video className="h-3.5 w-3.5 text-primary" /> : <MessageCircleHeart className="h-3.5 w-3.5 text-primary" />}{r.from_name}</span>
      <span className="text-xs text-muted-foreground">{when(r.created_at)}</span>
      {!r.seen && <span className="text-[10px] uppercase tracking-wider font-mono text-primary">new</span>}
      {onDelete && <button type="button" onClick={() => onDelete(r.id)} className="ml-auto text-muted-foreground hover:text-destructive" aria-label="Remove reply" data-testid={`reply-delete-${r.id}`}><Trash2 className="h-3.5 w-3.5" /></button>}
    </div>
    {r.text && <p className="mt-1.5 whitespace-pre-wrap leading-relaxed font-serif" data-testid={`reply-text-${r.id}`}>{r.text}</p>}
    {r.media_url && (r.kind === "video"
      ? <video controls playsInline preload="metadata" src={src(r)} className="mt-2 w-full max-w-md rounded-lg bg-black aspect-video" data-testid={`reply-media-${r.id}`} />
      : <audio controls preload="metadata" src={src(r)} className="mt-2 w-full" data-testid={`reply-media-${r.id}`} />)}
  </li>
);

// Replies relatives left on shared links, shown under the letter in the vault.
export const LetterReplies = ({ doc, readOnly }) => {
  const [replies, setReplies] = useState([]);
  useEffect(() => { let on = true; recordingReplies(doc.id).then((r) => on && setReplies(r.replies)).catch(() => {}); return () => { on = false; }; }, [doc?.id]);
  const remove = async (id) => { try { await deleteRecordingReply(doc.id, id); setReplies((xs) => xs.filter((r) => r.id !== id)); toast.success("Reply removed"); } catch { toast.error("Couldn't remove the reply"); } };
  if (!replies.length) return null;
  return (
    <div className="mt-4" data-testid="letter-replies">
      <div className="text-xs uppercase tracking-wider font-mono text-muted-foreground mb-1.5 flex items-center gap-1.5"><MessageCircleHeart className="h-3.5 w-3.5" /> Replies from family · {replies.length}</div>
      <ul className="grid gap-2">{replies.map((r) => <ReplyCard key={r.id} r={r} src={(x) => `${API}${x.media_url}`} onDelete={readOnly ? null : remove} />)}</ul>
    </div>
  );
};
